import request from '@/utils/request'

// 获取所有可展示留言
export function frontEnd_api(query) {
  return request({
    url: '/api/frontEnd/all',
    method: 'get',
    params: query
  })
}


// 获取人员列表
export function characterInformationList_api(query) {
  return request({
    url: '/api/frontEnd/characterInformationList',
    method: 'get',
    params: query
  })
}
// 获取网络列表
export function selectByTypeList_api(query) {
  return request({
    url: '/api/frontEnd/selectByType',
    method: 'get',
    params: query
  })
}
// 获取点击次数
export function getclicks_api(query) {
  return request({
    url: '/api/frontEnd/clicks',
    method: 'get',
    params: query
  })
}


// 新增留言
export function addfrontEnd_api(data) {
  return request({
    url: '/api/frontEnd/add',
    method: 'post',
    data: data
  })
}
// 新增点击
export function addclickfrontEnd_api(data) {
  return request({
    url: '/api/frontEnd/click',
    method: 'post',
    data: data
  })
}
// big图片
export function bigimages_api(query) {
  return request({
    url: '/api/frontEnd/images',
    method: 'get',
    params: query
  })
}
// top图片
export function topimages_api(query) {
  return request({
    url: '/api/frontEnd/rotationImages',
    method: 'get',
    params: query
  })
}
// 配置
export function configData_api(query) {
  return request({
    url: '/api/configuration/config',
    method: 'get',
    params: query
  })
}

//getConfiguration_api 获取配置详情
export function getConfiguration_api(query) {
  return request({
    url: '/api/configuration/getConfiguration/'+query,
    method: 'get',
   
  })
}

//logisticsList_api 获取物流列表
export function logisticsList_api(query) {
  return request({
    url: '/api/logistics/list',
    method: 'post',
    data: query
  })
}
